export class JobMetrics {
    constructor(
        public VIEWS: number = 0,
        public LIKES: number = 0,
    ){}
}